import React, { useState, useRef, useCallback } from "react";
import { Router, Link } from "@reach/router";

import "firebase/firestore";

import "@reach/combobox/styles.css";
import Home from "./Components/Home";

import Fox from "./Fox.png";
import Owl from "./OwlIcon.png";
import Water from "./Watericon.png";
import Map from "./Components/Map";
import LandingPage from "./Components/LandingPage";
import Instructions from "./Components/Instructions";
import Credits from "./Components/Credits";
import About from "./Components/About";

require("firebase/firestore");

function App() {
  const [folk, selectFolk] = React.useState(null);

  const onFolkClick = (number) => {
    const folkArr = [
      {
        name: "bird",
        url: Owl,
      },
      {
        name: "water",
        url: Water,
      },
      {
        name: "mammal",
        url: Fox,
      },
    ];
    selectFolk(folkArr[number]);
  };

  return (
    <div>
      <Router>
        <LandingPage path="/" />
        <Home path="/home/:alpha" />
        <Map path="/:alpha/:type" />
        <Instructions path="/inst/:alpha" />
        <Instructions path="/inst/:alpha/:type" />
        <Credits path="/credits/:alpha" />
        <Credits path="/credits/:alpha/:type" />
        <About path="/about/:alpha" />
        <About path="/about/:alpha/:type" />
      </Router>
    </div>
  );
}
export default App;
